// Auto-generated per-query builders for Step
// DO NOT EDIT - Changes will be overwritten

import { QueryBuilderBase } from '@sourcepilot/framework/query-builder-base';
import { NeoNodeBase } from '@sourcepilot/framework/neo-node-base';
import { RelationshipManager } from '@sourcepilot/framework/relationship-manager';
import { Relationship } from '@sourcepilot/framework/relationship';
import { StepReadAPI, StepWriteAPI, StepReadAPISchema, StepWriteAPISchema } from '../types/step';
import { ModelRegistry } from '../../registries/model-registry';
import { AtScope, CreatedBy, HasContext, HasModelRequests, HasSteps, WritesTo } from '../../relationships/relationship';

import { ModelRequest } from './modelrequest';
import { SecurityScope } from '../../shared/api/securityscope';
import { Thread } from './thread';
import { User } from '../../base/api/user';
import { ScopedNode } from '../../shared/api/scopednode';
import { StepTask } from '../../llm_task/api/steptask';



// Field names for order_by on ModelRequest
type ModelRequestFields = "created_at" | "-created_at" | "order_index" | "-order_index";



// Builder chain for query: chat-step-by-id

export interface ChatStepByIdBuilder_0 {
  get(id: string): ChatStepByIdBuilder_1;
  filter(conditions: { id: string }): ChatStepByIdBuilder_1;
}

export interface ChatStepByIdBuilder_1 {
  all(): Promise<Step[]>;
  first(): Promise<Step | null>;
  get(): Promise<Step[]>;
  execute(): Promise<Step[]>;
}

// Builder chain for query: chat-step-with-requests

export interface ChatStepWithRequestsBuilder_0 {
  get(id: string): ChatStepWithRequestsBuilder_1;
  filter(conditions: { id: string }): ChatStepWithRequestsBuilder_1;
}

export interface ChatStepWithRequestsBuilder_1 {
  model_requests: ChatStepWithRequestsBuilder_2;
}

export interface ChatStepWithRequestsBuilder_2 {
  orderBy(field?: ModelRequestFields): ChatStepWithRequestsBuilder_2;
  all(): Promise<ModelRequest[]>;
  first(): Promise<ModelRequest | null>;
  get(): Promise<ModelRequest[]>;
  execute(): Promise<ModelRequest[]>;
}


// Union of all query entry points
export type StepQueryBuilder = ChatStepByIdBuilder_0 | ChatStepWithRequestsBuilder_0;

// Available query names for .setQuery()
export type StepQueryNames = "chat-step-by-id" | "chat-step-with-requests";

// Type narrowing for .setQuery()
export type StepBuilderForQuery<Q extends StepQueryNames> =
  Q extends "chat-step-by-id" ? ChatStepByIdBuilder_0
  : Q extends "chat-step-with-requests" ? ChatStepWithRequestsBuilder_0
  : never;

// Type for instance setQuery - returns post-filter/post-get builder
export type StepInstanceQueryResult<Q extends StepQueryNames> =
  Q extends "chat-step-by-id" ? ChatStepByIdBuilder_1
  : Q extends "chat-step-with-requests" ? ChatStepWithRequestsBuilder_1
  : never;

// Map path signatures to query names
const QUERY_PATH_MAP: Record<string, string> = {
  '': 'chat-step-by-id',
  'model_requests|order_by': 'chat-step-with-requests',
};

// Model-specific QueryBuilder implementation
class QueryBuilderImpl extends QueryBuilderBase {
  constructor(
    modelName: string,
    path: string[] = [],
    params: Record<string, any> = {},
    fetchFn?: (path: string, options?: RequestInit) => Promise<any>,
    queryName?: string,
    scopedParams: Record<string, Record<string, any>> = {}
  ) {
    super(modelName, path, params, fetchFn, queryName, scopedParams, QUERY_PATH_MAP, QueryBuilderImpl);
  }

  setQuery<Q extends StepQueryNames>(queryName: Q): StepBuilderForQuery<Q> {
    // Create new builder with queryName set to bypass path lookup
    return new QueryBuilderImpl(
      this.modelName,
      this.path,
      this.params,
      this.fetchFn,
      queryName,
      this.scopedParams
    ) as any;
  }
}

Object.defineProperty(QueryBuilderImpl.prototype, 'model_requests', {
  get() {
    return new QueryBuilderImpl('ModelRequest', [...this.path, 'model_requests'], this.params, this.fetchFn, this.queryName, this.scopedParams);
  },
  enumerable: true,
  configurable: true
});

export interface Step extends Partial<StepReadAPI> {}
export class Step extends NeoNodeBase<StepReadAPI, StepWriteAPI> {
  // Static label for identifying this model type (minification-safe)
  static readonly label = "Step";
  static readonly readSchema = StepReadAPISchema;
  static readonly writeSchema = StepWriteAPISchema;

  // Per-relationship metadata, keyed by property name on this class.
  // See `framework/data/dag-sync/reverse-property.ts` for how the DAG
  // client uses (relClass, direction) to route patches back to the
  // correct property — especially for polymorphic-source rels.
  static readonly relationships: Record<string, {
    target: string;
    cardinality: 'one' | 'many';
    isParent: boolean;
    relClass: string;
    direction: 'in' | 'out';
  }> = {
    thread: { target: "Thread", cardinality: "one", isParent: true, relClass: "HasSteps", direction: "in" },
    created_by: { target: "User", cardinality: "one", isParent: false, relClass: "CreatedBy", direction: "out" },
    context_items: { target: "ScopedNode", cardinality: "many", isParent: false, relClass: "HasContext", direction: "out" },
    model_requests: { target: "ModelRequest", cardinality: "many", isParent: false, relClass: "HasModelRequests", direction: "out" },
    step_tasks: { target: "StepTask", cardinality: "many", isParent: false, relClass: "WritesTo", direction: "in" },
  };

  protected get modelName(): string {
    return 'Step';
  }

  // Instance getter for label (used in DAG sync and type identification)
  get _label(): string {
    return Step.label;
  }


  constructor(data: Partial<StepWriteAPI> = {}) {
    super(data);
  }

/**
   * Load instance from server data with Zod validation
   * Recursively instantiates nested relationship objects
   *
   * @param data - Node data from API (ReadAPI format)
   * @param loadContext - Optional LoadContext from backend QueryResult for eager-loaded relationships
   * @returns Class instance with nested relationships instantiated
   */
  static load(data: StepReadAPI, loadContext?: Record<string, any>): Step {
    // Import relationship loaders
    const { loadOneRelationship, loadManyRelationship } = require('@sourcepilot/framework/load-relationship');

    // Strip relationship fields before validation (they'll be processed separately)
    const { created_by, context_items, model_requests, security_scope, thread, step_tasks, _label, ...dataToValidate } = data as any;

    // Validate with Zod schema (only non-relationship fields)
    const validated = StepReadAPISchema.parse(dataToValidate);

    // Re-add relationship fields to validated data for processing
    const dataWithRelationships: any = { ...validated, created_by: created_by, context_items: context_items, model_requests: model_requests, security_scope: security_scope, thread: thread, step_tasks: step_tasks };

    // If loadContext provided, use NeoGraphParser to reconstruct relationships
    if (loadContext && validated.id) {
      // Import NeoGraphParser dynamically to avoid circular dependencies
      const { NeoGraphParser } = require('@sourcepilot/framework/neograph-utils');
      const parser = new NeoGraphParser();
      const graphNodes = parser.parse([validated], loadContext);

      if (graphNodes.length > 0) {
        // Convert graph structure back to plain object with relationships
        const withRelationships = parser.toPlainObject(graphNodes[0]);
        // Recursively instantiate via ModelRegistry (without loadContext to avoid infinite loop)
        return Step.load(withRelationships);
      }
    }

    // Recursively instantiate nested relationships from inline data
    const processed: any = { ...dataWithRelationships };

    // Process relationships: convert to class instances and store with private property names
    loadOneRelationship(processed, 'created_by', 'User', ModelRegistry);
    loadManyRelationship(processed, 'context_items', 'ScopedNode', ModelRegistry);
    loadManyRelationship(processed, 'model_requests', 'ModelRequest', ModelRegistry);
    loadOneRelationship(processed, 'security_scope', 'SecurityScope', ModelRegistry);
    loadOneRelationship(processed, 'thread', 'Thread', ModelRegistry);
    loadManyRelationship(processed, 'step_tasks', 'StepTask', ModelRegistry);
    // Create instance with processed data (constructor uses Object.assign)
    // Private properties (_*) won't conflict with relationship getters
    const instance = new Step(processed as any);

    return instance;
  }

  static filter(conditions: Record<string, any>): StepQueryBuilder {
    return new QueryBuilderImpl('Step').filter(conditions) as any;
  }

  static all(): StepQueryBuilder {
    return new QueryBuilderImpl('Step') as any;
  }

  static async first(): Promise<Step | null> {
    const results = await new QueryBuilderImpl('Step').execute();
    return results[0] || null;
  }


  static setQuery<Q extends StepQueryNames>(queryName: Q): StepBuilderForQuery<Q> {
    const builder = new QueryBuilderImpl('Step');
    return builder.setQuery(queryName);
  }

  /**
   * Instance method to create queries pre-filtered by this instance's ID.
   * Enables queries like: thread.setQuery('thread-with-steps').steps.all()
   * Returns the same builder type as static method after applying ID filter.
   */
  setQuery<Q extends StepQueryNames>(queryName: Q): StepInstanceQueryResult<Q> {
    if (!this.id) {
      throw new Error('Cannot query an unsaved instance without an ID');
    }
    // Create a query builder and apply the ID
    const builder = Step.setQuery(queryName) as any;

    // Try .get(id) first (if the query starts with Thread.get())
    // Otherwise use .filter({id}) (if the query starts with Thread.filter(id=...))
    // The return type mapping handles which builder stage is returned
    if (builder.get && typeof builder.get === 'function') {
      return builder.get(this.id);
    } else if (builder.filter && typeof builder.filter === 'function') {
      return builder.filter({ id: this.id });
    }
    return builder;
  }

  // Relationship manager for 'model_requests' - Python ORM style (cached)
  get model_requests(): RelationshipManager<this, ModelRequest> {
    return this.getOrCreateRelationshipManager('model_requests', () => {
      return new RelationshipManager(this, 'model_requests', 'many', HasModelRequests as typeof Relationship);
    });
  }

  // Relationship manager for 'security_scope' - Python ORM style (cached)
  get security_scope(): RelationshipManager<this, SecurityScope> {
    return this.getOrCreateRelationshipManager('security_scope', () => {
      return new RelationshipManager(this, 'security_scope', 'one', AtScope as typeof Relationship);
    });
  }

  // Relationship manager for 'thread' - Python ORM style (cached)
  get thread(): RelationshipManager<this, Thread> {
    return this.getOrCreateRelationshipManager('thread', () => {
      return new RelationshipManager(this, 'thread', 'one', HasSteps as typeof Relationship);
    });
  }

  // Relationship manager for 'created_by' - Python ORM style (cached)
  get created_by(): RelationshipManager<this, User> {
    return this.getOrCreateRelationshipManager('created_by', () => {
      return new RelationshipManager(this, 'created_by', 'one', CreatedBy as typeof Relationship);
    });
  }

  // Relationship manager for 'context_items' - Python ORM style (cached)
  get context_items(): RelationshipManager<this, ScopedNode> {
    return this.getOrCreateRelationshipManager('context_items', () => {
      return new RelationshipManager(this, 'context_items', 'many', HasContext as typeof Relationship);
    });
  }

  // Relationship manager for 'step_tasks' - Python ORM style (cached)
  get step_tasks(): RelationshipManager<this, StepTask> {
    return this.getOrCreateRelationshipManager('step_tasks', () => {
      return new RelationshipManager(this, 'step_tasks', 'many', WritesTo as typeof Relationship);
    });
  }

}
